(function () {
    "use strict";

    // Allow for dates to be automatically resolved from Json.  I would have overridden JSON.parse so that is happens automatically every
    // time JSON.parse is called, but it would most certainly break Bryan's stuff.  I also added the ability to set your own 
    // JSON.parse reviver which allows for transformations.  Yes, I know there is a transformRequest option, but this is more powerful.
    //
    // Example: $http.get(url, { resolveDates: true, jsonReviver: transform });
    angular
        .module(app.modules.app.name)
        .config(httpConfig);

    var
        JSON_PROTECTION_PREFIX = /^\)\]\}',?\n/,
        APPLICATION_JSON = 'application/json',
        JSON_START = /^\[|^\{(?!\{)/,
        JSON_ENDS = { '[': /]$/, '{': /}$/ },
        rISODateOrTime = /^(?:(\d{4})-([01]\d)-([0-3]\d)T([0-2]\d):([0-5]\d):([0-5]\d)(?:\.(\d{1,3})\d*)?([+-][0-2]\d:[0-5]\d|Z)?|PT(?:([0-2]?\d)H)?(?:([0-5]?\d)M)?(?:([0-5]?\d)(?:\.(\d{1,3})\d*)?S)?)$/,
        concat = Array.prototype.concat;

    httpConfig.$inject = ['$httpProvider'];
    function httpConfig($httpProvider) {
        $httpProvider.defaults.transformResponse = [defaultHttpResponseTransform];

        function defaultHttpResponseTransform(data, headers, status, config) {
            config = config || {};
            if (angular.isString(data)) {
                var
                    tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim(),
                    resolveDates = config.resolveDates === true,
                    reviver = config.jsonReviver;

                if (tempData) { 
                    var contentType = headers('Content-Type');
                    if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
                        reviver = createReviver(resolveDates ? dateReviver : null, reviver)
                        data = fromJson(tempData, reviver);
                    }
                }
            }

            return data;
        }

        function isJsonLike(str) {
            var jsonStart = str.match(JSON_START);
            return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
        }

        function fromJson(json, reviver) {
            return angular.isString(json) ? JSON.parse(json, reviver) : json;
        }

        function createReviver() {
            var args = concat.apply([], arguments).filter(angular.isFunction);
            return args.length != 0 ? reviver : undefined;

            function reviver(key, value) {
                return args.reduce(reduce.bind(this), value);

                function reduce(value, reviver) {
                    return reviver.call(this, key, value);
                }
            }
        }

        function dateReviver(key, value) {
            if (typeof value === 'string') {
                var match = rISODateOrTime.exec(value);
                if (match) {
                    // Is a Time PT{XX}H{XX}M{XX.XXXXX}S ?
                    if (match[9]) {
                        var now = new Date();
                        value = new Date(now.getFullYear(), now.getMonth(), now.getDate(), match[9] || 0, match[10] || 0, match[11] || 0, match[12] || 0);
                    }

                    // Is a Date with either trailing "Z" (UTC) or timezone offset "-04:20". ?  // should never go into this if!
                    else if (match[8]) {
                        value = new Date(value);
                    }

                    // Is a Local Date (no timezone or utc) ?
                    else {
                        value = new Date(match[1], match[2] - 1, match[3], match[4], match[5], match[6], match[7] || 0);
                    }
                }
            }
            return value;
        }
    }
})();

